import type { ChatComposerLibraryTab } from "./components/chat-composer/chat-composer-add-menu"

export type AnalyticsSink = {
  track: (event: string, properties?: Record<string, unknown>) => void
}

export type PromptUsedProperties = {
  promptName: string
  promptType: "chat" | "system" | "skill"
  source: "user" | "managed"
  insertMode: "replace" | "append"
  surface: "web" | "word-addin"
  isAuthor?: boolean
}

export function trackPromptUsed(sink: AnalyticsSink | null, properties: PromptUsedProperties) {
  sink?.track("Prompt Used", properties)
}

export type SkillOpenedProperties = {
  skillId: string
  source: "user" | "managed"
  surface: "web" | "word-addin"
}

export function trackSkillOpened(sink: AnalyticsSink | null, properties: SkillOpenedProperties) {
  sink?.track("skill_opened", properties)
}

export type ChatFilesSource = "drop" | "paste"

export type ChatFilesAddedProperties = {
  surface: "web" | "word-addin"
  conversationId: string | null
  projectId?: string
  fileCount: number
}

const CHAT_FILES_ADDED_EVENT_BY_SOURCE: Record<ChatFilesSource, string> = {
  drop: "chat_files_dropped",
  paste: "chat_files_pasted",
}

export function trackChatFilesAdded(sink: AnalyticsSink | null, source: ChatFilesSource, properties: ChatFilesAddedProperties) {
  sink?.track(CHAT_FILES_ADDED_EVENT_BY_SOURCE[source], properties)
}

export type ChatComposerAnalyticsEvent =
  | { name: "chat_composer_past_chat_attached"; attachedConversationId: string }
  | { name: "chat_composer_library_opened"; tab: ChatComposerLibraryTab }
  | { name: "chat_composer_model_selected"; model: string }
  | { name: "chat_composer_agent_settings_saved" }
  | { name: "chat_composer_workspace_attached"; workspaceId: string }
export type ChatComposerAnalytics = {
  sink: AnalyticsSink | null
  surface: "web" | "word-addin"
  conversationId: string | null
}

export function trackChatComposerEvent(
  analytics: ChatComposerAnalytics,
  { name, ...properties }: ChatComposerAnalyticsEvent,
) {
  analytics.sink?.track(name, { surface: analytics.surface, conversationId: analytics.conversationId, ...properties })
}
